import React, { useEffect, useState } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { getNowInEpochTime } from "../../services/dateService";
import {
	createYourControl,
	getUserSettings,
	getCompanionStartDate,
} from "../../services/userService";
import { Page1 } from "./YourControls/Page1";
import { Page2 } from "./YourControls/Page2";
import { Page3 } from "./YourControls/Page3";

export const pathRoot = "/setupdata/yourcontrol";

export const schema = {
	type: "object",
};

function YourControl() {
	const handleSaveFailure = (error) => {
		console.error(`Error saving data in ${pathRoot}: `, error);
		// history.push("/dashboard");
	};

	const [yourControlSettings, setYourControlSettings] = useState({});
	const [companionStartDate, setCompanionStartDate] = useState(
		getNowInEpochTime()
	);

	useEffect(() => {
		var yourControl = getUserSettings().yourControl;
		if (yourControl) {
			setYourControlSettings(yourControl);
		} else {
			setYourControlSettings(createYourControl());
		}

		setCompanionStartDate(getCompanionStartDate());
	}, []);

	return (
		<Switch>
			<Route path={`${pathRoot}/1`}>
				<Page1
					companionStartDate={companionStartDate}
					yourControlSettings={yourControlSettings}
					handleSaveFailure={handleSaveFailure}
				/>
			</Route>

			<Route path={`${pathRoot}/2`}>
				<Page2
					yourControlSettings={yourControlSettings}
					handleSaveFailure={handleSaveFailure}
				/>
			</Route>

			<Route path={`${pathRoot}/3`}>
				<Page3
					yourControlSettings={yourControlSettings}
					handleSaveFailure={handleSaveFailure}
				/>
			</Route>

			<Redirect from={pathRoot} to={`${pathRoot}/1`} />
		</Switch>
	);
}

export { YourControl };
